import { injectStyles, getVariant, Box, BoxProps } from '@apia/theme';
import { forwardRef } from 'react';
import { RequiredMark } from './RequiredMark';
import { getLabelName, getLabelTooltip, TLabel } from '@apia/util';

export type TCheckboxLabel = {
  /**
   * Permite mostrar un mensaje de error debajo del campo
   */
  error?: string;
  hideRequiredMark?: boolean;
  label: string | TLabel;
  /**
   * La propiedad required se utiliza para mostrar el * de requerido.
   *
   * @see requiredMarkPosition
   * @see hideRequiredMark
   */
  required?: boolean;
  requiredMarkPosition?: 'before' | 'after';
};

injectStyles('layout.common.components.checkboxLabel', {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,

  '.checkboxLabel__label': {
    fontWeight: 'bold',
  },
});

export const CheckboxLabel = forwardRef<
  HTMLDivElement,
  TCheckboxLabel & BoxProps
>(
  (
    {
      as,
      children,
      error,
      hideRequiredMark,
      label,
      required,
      requiredMarkPosition = 'after',
      ...props
    },
    ref,
  ) => {
    return (
      <Box
        as={as ?? 'label'}
        {...props}
        className={`checkboxLabel ${props.className ?? ''} ${error ? 'field__withError' : ''}`}
        {...getVariant('layout.common.components.checkboxLabel')}
        aria-label={props['aria-label'] ?? getLabelTooltip(label)}
        ref={ref}
      >
        <Box className="label_row">
          {children}
          <Box className={`checkboxLabel__label`}>
            {requiredMarkPosition === 'before' && (
              <RequiredMark
                isRequired={required}
                isReadonly={hideRequiredMark}
                isFormReadonly={hideRequiredMark}
              />
            )}
            {getLabelName(label)}
            {requiredMarkPosition === 'after' && (
              <RequiredMark
                isRequired={required}
                isReadonly={hideRequiredMark}
                isFormReadonly={hideRequiredMark}
              />
            )}
          </Box>
        </Box>
        {error && <Box className="checkboxLabel__error">{error}</Box>}
      </Box>
    );
  },
);

CheckboxLabel.displayName = 'CheckboxLabel';
